import React from 'react';
import cls from 'classnames';
import range from '~/utils/list/range';

export const Guidelines = (props) => {
	const renderGuide = (type) => {
		const list = [];
		for (const key of range(props[`${type}s`] + 1)) {
			list.push(<span key={key} className={props.classes[type]} />);
		}
		return list;
	};
	return (
		/^development$/i.test(process.env.NODE_ENV) && (
			<div
				className={cls(props.classes.root, props.className)}
				style={{ maxWidth: props.maxWidth, maxHeight: props.maxHeight }}>
				{props.columns > 0 && <div className={cls(props.classes.columns)}>
					{renderGuide('column')}
				</div>}
				{props.rows > 0 && <div className={cls(props.classes.rows)}>
					{renderGuide('row')}
				</div>}
			</div>
		)
	);
};

export default Guidelines;
